import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { InventoryFormikValuesDto } from '../../../../types/InventoryFormikValuesDto';
import { quantityGetDtoToFormik } from '../../../../types/convertors/quantityGetDtoToFormik';
import { formikValuesAndItemToChangeStockTransaction } from '../../../../types/convertors/formikValuesAndItemToChangeStockTransaction';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import GenericProductsApi from '../../../../services/api/GenericProductsApi';
import InventoryAddEditForm from '../components/InventoryAddEditForm';

import { fullSchema } from '../InventorySchema';

export default function InventorySplit(): JSX.Element {
  const { genericId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { item } = location?.state ?? {};
  const [generic, setGeneric] = useState(null);

  const saveItem = async (
    values: InventoryFormikValuesDto,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);

    const newValues = formikValuesAndItemToChangeStockTransaction(values, item, genericId);
    const result = await InventoryApi.change(newValues);

    if (result.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/in-warehouse/${item.warehouse.id}/${genericId}`);
    } else {
      setSubmitting(false);
    }
  };

  const getGenericItem = async (): Promise<void> => {
    const result = await GenericProductsApi.get(genericId);
    setGeneric(result.data);
  };

  const initialValues = quantityGetDtoToFormik(item, true);
  const formik = useFormik({
    initialValues,
    validationSchema: fullSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  useEffect(() => {
    if (genericId) {
      getGenericItem();
    }
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/inventory/list-for-generic/${genericId}`);
        }}
        title="Change Warehouse Stock"
      />
      {generic && <InventoryAddEditForm formikProps={formik} generic={generic} />}
    </WhitePad>
  );
}
